// className 합치기
export const classNameBind = (arr: string[]) =>
  arr.filter(el => el !== '').join(' ');
// string 문자열 찾기
export const setSearchStr = (str: string, val: string) => str.includes(val);
// 기초 유틸
export const isString = <T = unknown>(str: string | T): str is string =>
  typeof str === 'string';
export const isObject = (val: unknown) => typeof val === 'object';
export const isFunction = (val: unknown) => typeof val === 'function';
export const isBoolean = (val: unknown) => typeof val === 'boolean';
export const isUndefined = (val: unknown) => typeof val === 'undefined';
export const isDefined = (val: unknown) => typeof val !== 'undefined';
export const isNumber = (val: unknown) => typeof val === 'number';
export const isArray = (val: unknown) => Array.isArray(val);
export const isDate = (val: unknown) =>
  Object.prototype.toString.call(val) === '[object Date]';
export const isEmpty = (val: any) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  val == null || !(Object.keys(val) || val).length;
export const isEmptyArray = (val: unknown[]) =>
  Array.isArray(val) && val.length === 0;
export const isEmptyObj = (val: { [key: string]: unknown }): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  Object(val) && val !== null && Object.values(val).length === 0;
export const parseIntOrDefault = (val: string, defaultVal: unknown) => {
  // eslint-disable-next-line no-underscore-dangle
  const _int = parseInt(val, 10);
  // eslint-disable-next-line no-restricted-globals
  return isNaN(_int) ? defaultVal : _int;
};
export const validLen = (val: string | unknown[], cond: boolean) =>
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  cond !== false ? `${val}`.trim().length : val.length;
// typeof window
export const IS_BROWSER = typeof window !== 'undefined';

// string 문자열에 콤마(',')를 찍고, 구분자를 뒤에 붙여준다
export const setComma = (str: string, separator?: string) => {
  let result = '';

  if (!isEmpty(str) || str === '0') {
    result = String(str).replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');

    if (!isEmpty(separator)) {
      result += separator;
    }
  }

  return result;
};

// Array Size만큼 분리.
export const arrayDivision = (data: unknown[], size = 1) => {
  const items = [...data];
  const arr = [];

  while (items.length) {
    arr.push(items.splice(0, size));
  }

  return arr;
};

export const getScrollbarWidth = () =>
  `${window.innerWidth - document.documentElement.clientWidth}px`;

export const checkAppVersion = (appVer = '0.0.0', chackVer = '0.0.0') => {
  if (appVer === chackVer) {
    return 'same';
  }

  const appVers = appVer.split('.');
  const chackVers = chackVer.split('.');

  let result = '';
  chackVers.some((val, index) => {
    // 현재 앱 버전 값
    const appVal = parseInt(`${appVers[index] || 0}`, 10);
    // 확인 할 버전 값
    const checkVal = parseInt(`${val || 0}`, 10);

    if (appVal > checkVal) {
      result = 'high';
      return true;
    }
    if (appVal < checkVal) {
      result = 'low';
      return true;
    }
    result = 'same';
    return false;
  });

  return result;
};

export function lowerCaseObjectKey(obj: { [key: string]: string }) {
  return Object.keys(obj).reduce((result, key) => {
    // eslint-disable-next-line no-param-reassign
    result[key.toLowerCase()] = obj[key];
    return result;
  }, {} as { [key: string]: string });
}
